"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("@/res/globalStyle.css");
var _tinycon = _interopRequireDefault(require("tinycon"));
var _StateBrowser = _interopRequireDefault(require("@/components/StateBrowser"));
var _AppSettings = _interopRequireDefault(require("@/components/AppSettings"));
var _Container = _interopRequireDefault(require("@/components/Container"));
var _ControlInput = _interopRequireDefault(require("@/components/ControlInput"));
var _MediaViewer = _interopRequireDefault(require("@/components/MediaViewer"));
var _UserAvatarCommon = _interopRequireDefault(require("@/components/UserAvatarCommon"));
var _Sidebar = require("@/components/Sidebar");
var _ThemeManager = _interopRequireDefault(require("@/libs/ThemeManager"));
var Notifications = _interopRequireWildcard(require("@/libs/Notifications"));
var bufferTools = _interopRequireWildcard(require("@/libs/bufferTools"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let log = _Logger.default.namespace('App.vue');
var _default = exports.default = {
  components: {
    StateBrowser: _StateBrowser.default,
    Container: _Container.default,
    ControlInput: _ControlInput.default,
    MediaViewer: _MediaViewer.default,
    AvatarCommon: _UserAvatarCommon.default
  },
  props: ['startupComponent'],
  data() {
    return {
      hasStarted: false,
      // When on mobile screens, the statebrowser turns into a drawer
      stateBrowserDrawOpen: false,
      // If set, will become the main view instead of a buffer/nicklist container
      activeComponent: null,
      activeComponentProps: {},
      // If set, will become the main view when no networks are available to be shown
      // and there is no active component set
      fallbackComponent: null,
      fallbackComponentProps: {},
      mediaviewerOpen: false,
      mediaviewerUrl: '',
      mediaviewerComponent: null,
      mediaviewerComponentProps: {},
      mediaviewerIframe: false,
      sidebarState: new _Sidebar.State()
    };
  },
  computed: {
    networks() {
      return this.$state.networks;
    },
    network() {
      return this.$state.getActiveNetwork();
    },
    buffer() {
      return this.$state.getActiveBuffer();
    },
    currentThemeName() {
      const theme = _ThemeManager.default.instance().currentTheme();
      return theme ? theme.name.toLowerCase() : '';
    }
  },
  created() {
    this.listenForActiveComponents();
    this.watchForThemes();
    this.initStateBrowser();
    this.initMediaviewer();
    this.configureFavicon();
    this.listen(document, 'visibilitychange', this.onVisibilityChange);
    this.listen(document, 'keydown', event => this.onKeyDown(event));
    this.listen(window, 'focus', event => this.onFocus(event));
    this.listen(window, 'blur', event => this.onBlur(event));
    this.listen(window, 'touchstart', event => this.onTouchStart(event));
  },
  mounted() {
    this.trackWindowDimensions();
  },
  methods: {
    // Triggered by a startup screen event
    startUp(opts) {
      log('startUp()');
      if (opts && opts.fallbackComponent) {
        this.fallbackComponent = opts.fallbackComponent;
      }
      if (opts && opts.fallbackComponentProps) {
        this.fallbackComponentProps = opts.fallbackComponentProps;
      }

      // Make sure a startup screen can't trigger these more than once
      if (!this.hasStarted) {
        this.warnOnPageClose();

        // Wait for a click or sending a message before asking for notification permission.
        // Not doing this on an input event will get it blocked by some browsers.
        let requestNotificationPermission = () => {
          this.$state.$off('document.clicked', requestNotificationPermission);
          this.$state.$off('input.raw', requestNotificationPermission);
          Notifications.requestPermission(this.$state);
          Notifications.listenForNewMessages(this.$state);
        };
        this.$state.$once('document.clicked', requestNotificationPermission);
        this.$state.$once('input.raw', requestNotificationPermission);
      }
      this.hasStarted = true;
    },
    listenForActiveComponents() {
      this.listen(this.$state, 'active.component', (component, props) => {
        this.activeComponent = null;
        if (component) {
          this.activeComponentProps = props;
          this.activeComponent = component;
        }
      });
      this.listen(this.$state, 'active.component.toggle', (component, props) => {
        if (component === this.activeComponent) {
          this.activeComponent = null;
        } else if (component) {
          this.activeComponentProps = props;
          this.activeComponent = component;
        }
      });
    },
    watchForThemes() {
      this.listen(this.$state, 'theme.change', () => {
        this.$state.clearNickColours();
      });
    },
    initStateBrowser() {
      this.listen(this.$state, 'statebrowser.toggle', () => {
        this.stateBrowserDrawOpen = !this.stateBrowserDrawOpen;
      });
      this.listen(this.$state, 'statebrowser.show', () => {
        this.stateBrowserDrawOpen = true;
      });
      this.listen(this.$state, 'statebrowser.hide', () => {
        this.stateBrowserDrawOpen = false;
      });
    },
    initMediaviewer() {
      this.listen(this.$state, 'mediaviewer.show', url => {
        let opts = {};

        // The passed url may be a string or an options object
        if (typeof url === 'string') {
          opts = {
            url: url
          };
        } else {
          opts = url;
        }
        this.mediaviewerUrl = opts.url;
        this.mediaviewerComponent = opts.component;
        this.mediaviewerComponentProps = opts.componentProps;
        this.mediaviewerIframe = opts.iframe;
        this.mediaviewerOpen = true;
      });
      this.listen(this.$state, 'mediaviewer.hide', () => {
        this.mediaviewerOpen = false;
      });
    },
    configureFavicon() {
      // favicon bubble
      _tinycon.default.setOptions({
        width: 7,
        height: 9,
        color: '#ffffff',
        background: '#b32d2d',
        fallback: true
      });
      this.$state.$watch('ui.favicon_counter', newVal => {
        if (newVal) {
          _tinycon.default.setBubble(newVal);
        } else {
          _tinycon.default.reset();
        }
      });
      this.listen(this.$state, 'message.new', event => {
        let message = event.message;
        if (!message.isHighlight || message.ignore || this.$state.ui.app_has_focus) {
          return;
        }
        this.$state.ui.favicon_counter++;
      });
    },
    trackWindowDimensions() {
      // Track the window dimensions into the reactive ui state
      let trackWindowDims = () => {
        this.$state.ui.app_width = this.$el.clientWidth;
        this.$state.ui.app_height = this.$el.clientHeight;
        this.$state.ui.is_narrow = this.$el.clientWidth <= 769;
      };
      this.listen(window, 'resize', trackWindowDims);
      trackWindowDims();
    },
    warnOnPageClose() {
      window.onbeforeunload = () => {
        if (window.CHATSI_SESSION_EXPIRED_REDIRECT === true) {
          return undefined;
        }
        if (this.$state.setting('warnOnExit')) {
          return this.$t('window_unload');
        }
        return undefined;
      };
      window.onunload = () => {
        this.$state.networks.forEach(net => {
          if (net.connection.direct && net.state === 'connected') {
            net.ircClient.raw('QUIT', this.$state.setting('quitMessage') || 'Client Closed Connection');
          }
        });
      };
    },
    emitBufferPaste(event) {
      // bail if no buffer is active, or the buffer is hidden by another component
      if (!this.$state.getActiveBuffer() || this.activeComponent !== null) {
        return;
      }

      // bail if the target is an input-like element
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLSelectElement || event.target instanceof HTMLTextAreaElement) {
        return;
      }
      this.$state.$emit('buffer.paste', event);
    },
    emitDocumentClick(event) {
      this.$state.$emit('document.clicked', event);
    },
    onTouchStart(event) {
      // Parts of the UI adjust themselves if we're known to be using a touchscreen
      this.$state.ui.is_touch = true;
    },
    onBlur(event) {
      this.$state.ui.app_has_focus = false;
    },
    onFocus(event) {
      this.$state.ui.app_has_focus = true;
      this.$state.ui.favicon_counter = 0;
    },
    onVisibilityChange(event) {
      const newState = document.visibilityState === 'visible';
      const buffer = this.$state.getActiveBuffer();
      if (buffer) {
        buffer.isVisible = newState;
      }
      this.$state.ui.app_is_visible = newState;
    },
    onKeyDown(event) {
      this.$state.$emit('document.keydown', event);
      let meta = false;
      if (navigator.appVersion.indexOf('Mac') !== -1) {
        meta = event.metaKey;
      } else {
        // none english languages use ctrl + alt to access extended chars
        // make sure we do not interfere with that by only acting on ctrl
        meta = event.ctrlKey && !event.altKey;
      }
      if (meta && event.key === ']') {
        // meta + ]
        let buffer = bufferTools.getNextBuffer();
        if (buffer) {
          this.$state.setActiveBuffer(buffer.networkid, buffer.name);
        }
        event.preventDefault();
      } else if (meta && event.key === '[') {
        // meta + [
        let buffer = bufferTools.getPreviousBuffer();
        if (buffer) {
          this.$state.setActiveBuffer(buffer.networkid, buffer.name);
        }
        event.preventDefault();
      } else if (meta && event.key === 'o') {
        // meta + o
        this.$state.$emit('active.component.toggle', _AppSettings.default);
        event.preventDefault();
      } else if (meta && event.key === 's') {
        // meta + s
        let network = this.$state.getActiveNetwork();
        if (network) {
          network.showServerBuffer('settings');
        }
        event.preventDefault();
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["App"]
window._kiwi_exports.components.App = exports.default ? exports.default : exports;
